/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

// Medaica Report patient follow-up block at visual fidelity with the prototype
// (renderNextStep patient branch, cardiac_report_v0_5_6_dev_2.html lines
// 5277-5283). It renders BELOW the result cards. Styling lives in
// heart-report.css, scoped under .pcg-heart-report.
//
// The prototype also carries a renderSummary() patient block, but its target
// element (#summaryContainer) is never created by renderFeatures(), so the
// shipped report never shows a summary block — neither does this port.

import React from "react"
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore vendored plain-JS core with hand-written surface types
import { patientFollowUpText, currentHeartRateBpm, REPORT_LIMITATION_TEXT, EMERGENCY_BOILERPLATE_TEXT } from "./core"

export interface ReportLike {
  summary?: { patientText?: string }
  followUpNote?: { patientText?: string }
  features: unknown[]
}

export const HeartReportFollowUp: React.FC<{ report: ReportLike }> = ({ report }) => {
  const hr = currentHeartRateBpm(report.features as never)
  const followUp = patientFollowUpText(report.followUpNote?.patientText || "", report.features as never, hr)
  return (
    <section className="phr-followup" aria-label="Follow-Up Note" data-testid="heart-report-followup">
      <div className="phr-kicker">Follow-Up Note</div>
      <p className="phr-followup-text" data-testid="follow-up-text">
        {followUp}
      </p>
      <p className="phr-limitation">{REPORT_LIMITATION_TEXT}</p>
      <p className="phr-emergency">{EMERGENCY_BOILERPLATE_TEXT}</p>
    </section>
  )
}

export default HeartReportFollowUp
